import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable, of } from 'rxjs';
import { SuccessResponse } from './success.response';
import { Appointment } from "./appointment"
import { AppointmentType } from './appointment-type';
import { AuthService } from '../../auth.service';

@Injectable({
  providedIn: 'root'
})
export class AppointmentService {
  appointments: any = []
  appointmentTypes: any = []
  nextCheckTime = 0

  constructor(private http: HttpClient, private auth: AuthService) { 
    console.log("AppointmentService!!!!")
  }
  
  cancelAppointment(appointmentId: number): Observable<SuccessResponse> {
    var self = this;
    return this.http.delete<SuccessResponse>(`/api/appointments/${appointmentId}`)
    .pipe(map(response =>{
      self.appointmentTypes = response
      return response;
    }));
  }
  rescheduleAppointment(appointmentId: number, appointmentTimeId: number): Observable<SuccessResponse> {
    const baseHeaders = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http.post<SuccessResponse>("/api/appointments/reschedule",`appointmentId=${appointmentId}&appointmentTimeId=${appointmentTimeId}`,{headers: baseHeaders})
    .pipe(map(response => {
      return response;
    }));
  }
  getAppointmentTypes(): Observable<AppointmentType[]> {
    return this.http.get<AppointmentType[]>('/api/appointments/types')
    .pipe(map((response) => {
      return response;
    }));
  }
  getAppointments(year: number): Observable<Appointment[]> {
    var self = this

    if (this.appointments.length && this.nextCheckTime > Date.now() ) {
      console.log("returning cached appts")
      return of(this.appointments)
    }

    console.log("Fetching appts")

    return this.http.get<Appointment[]>(`/api/appointments?year=${year}`)
    .pipe(map(function(response){
      if (response.length > 0) {
          // refresh in 60s I guess
          self.nextCheckTime = Date.now() + 1000*60;
          self.appointments = response.map((appointment: Appointment) => {
            appointment.name = appointment.firstName + " " + appointment.lastName;

            appointment.completed = appointment.completed == true; // Do this since the SQL returns 0/1, and we want it to be false/true
            appointment.cancelled = appointment.cancelled == true; // Do this since the SQL returns 0/1, and we want it to be false/true
            appointment.started = appointment.cancelled || (appointment?.serviced_appointment?.timeIn ?? null) != null;
            // TODO: Not sure this logic for incomplete is good
            appointment.incomplete = !appointment.cancelled && !appointment.completed;
            appointment.inProgress = !appointment.cancelled && !appointment.incomplete && appointment.timeIn != null && !appointment.completed;
            
            if (appointment.completed) appointment.statusText = "Complete";
            else if (appointment.cancelled) appointment.statusText = "Cancelled";
            else if (!appointment.started) appointment.statusText = "Not Started";
            else if (appointment.inProgress) appointment.statusText = "In Progress";
            else if (appointment.incomplete) appointment.statusText = "Incomplete";
            else appointment.statusText = "Unknown";

            return appointment;
          });
        } 
        else {
          self.appointments = [];
        }

      return self.appointments;
    }));
  }
}
